module.exports = __webpack_public_path__ + "static/media/csv-logo.2147432d.svg";